import alt from 'framework/alt';

class I18nActions {
  constructor() {
    this.generateActions(
      'fetchStarted',
      'fetchSucceeded',
      'fetchFailed',
      'changeLocale',
    );
  }
}

export default alt.createActions(I18nActions);
